function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_6093",
  "data-name": "Group 6093",
  transform: "translate(-727 -714)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_5706",
  "data-name": "Group 5706",
  transform: "translate(814.961 876.008)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_5372",
  "data-name": "Rectangle 5372",
  width: 47.48,
  height: 5.715,
  transform: "translate(0 0)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_6092",
  "data-name": "Group 6092"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3442",
  "data-name": "Path 3442",
  d: "M58.562,140.549a17.585,17.585,0,0,0-17.305,14.64h-.264a29.281,29.281,0,1,1,0-58.562h3.192a17.548,17.548,0,0,0,34.61,0H108.6a17.548,17.548,0,0,0,34.61,0h3.192a35.137,35.137,0,1,0,0-70.274H122.717a17.548,17.548,0,0,0-34.61,0H64.419V2.928A2.927,2.927,0,0,0,61.49,0H2.928A2.927,2.927,0,0,0,0,2.928v46.85a2.927,2.927,0,0,0,2.928,2.928H61.49a2.927,2.927,0,0,0,2.928-2.928V32.209H88.107a17.548,17.548,0,0,0,34.61,0h23.688a29.281,29.281,0,1,1,0,58.562h-3.192a17.548,17.548,0,0,0-34.61,0H78.8a17.548,17.548,0,0,0-34.61,0H40.994a35.137,35.137,0,1,0,0,70.274h.264a17.548,17.548,0,0,0,34.61,0h6.12v-5.856h-6.12A17.585,17.585,0,0,0,58.562,140.549ZM29.281,5.856h5.856V17.569H29.281ZM58.562,46.85H5.856V5.856H23.425V20.5a2.927,2.927,0,0,0,2.928,2.928H38.065A2.927,2.927,0,0,0,40.994,20.5V5.856H58.562Zm46.85-5.856a11.712,11.712,0,1,1,11.712-11.712A11.724,11.724,0,0,1,105.412,40.993Zm20.5,40.993A11.712,11.712,0,1,1,114.2,93.7,11.724,11.724,0,0,1,125.909,81.987Zm-64.419,0A11.712,11.712,0,1,1,49.778,93.7,11.724,11.724,0,0,1,61.49,81.987ZM58.562,169.83a11.712,11.712,0,1,1,11.712-11.712A11.724,11.724,0,0,1,58.562,169.83Z",
  transform: "translate(734.508 720.816)"
}), /*#__PURE__*/React.createElement("g", {
  id: "noun_tick_3923816",
  transform: "translate(910.906 815.643)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3432",
  "data-name": "Path 3432",
  d: "M19.5,2A17.5,17.5,0,1,0,37,19.5,17.5,17.5,0,0,0,19.5,2Zm9.933,14.415-10.5,9.625a1.75,1.75,0,0,1-2.42-.052l-5.25-5.25a1.75,1.75,0,1,1,2.475-2.475L17.8,22.328l9.265-8.493a1.75,1.75,0,0,1,2.366,2.58Z",
  transform: "translate(-1 8)",
  fill: "#f37320"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_3424",
  "data-name": "Path 3424",
  d: "M11237.627,20190.123l-31.055,25.463v39.717h62.706v-38.818Z",
  transform: "translate(-10344.131 -19343.484)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3423",
  "data-name": "Path 3423",
  d: "M0,0,24.72,17.673",
  transform: "matrix(-0.259, 0.966, -0.966, -0.259, 882.496, 844.002)",
  fill: "none",
  stroke: "#f37320",
  strokeLinecap: "round",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_6091",
  "data-name": "Group 6091"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_5418",
  "data-name": "Rectangle 5418",
  width: 73,
  height: 61,
  transform: "translate(727 714)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_6090",
  "data-name": "Group 6090",
  transform: "translate(138.164 226.252)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_5417",
  "data-name": "Rectangle 5417",
  transform: "translate(609.836 491.747)",
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("rect", {
  width: 52,
  height: 59,
  rx: 5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1.5,
  y: 1.5,
  width: 49,
  height: 56,
  rx: 3.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_3490",
  "data-name": "Path 3490",
  d: "M9693.379,17711.166h38.451",
  transform: "translate(-9076.687 -17209.279)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3491",
  "data-name": "Path 3491",
  d: "M9693.379,17711.166h38.451",
  transform: "translate(-9076.687 -17202.943)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3492",
  "data-name": "Path 3492",
  d: "M9693.379,17711.166H9712.6",
  transform: "translate(-9076.687 -17190.848)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3493",
  "data-name": "Path 3493",
  d: "M9693.379,17711.166H9712.6",
  transform: "translate(-9076.687 -17184.514)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3494",
  "data-name": "Path 3494",
  d: "M9693.379,17711.166H9712.6",
  transform: "translate(-9076.687 -17178.178)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3495",
  "data-name": "Path 3495",
  d: "M9693.379,17711.166H9712.6",
  transform: "translate(-9076.687 -17170.998)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  width: 27,
  height: 26,
  transform: "translate(633.836 517.747)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5",
  "data-name": "Path 5",
  d: "M-707.01,13l-5.744-5.736v16a.832.832,0,0,1-.832.832h-.005a.832.832,0,0,1-.832-.832v-16L-720.167,13a.832.832,0,0,1-1.176,0h0a.832.832,0,0,1,0-1.176l7.165-7.165a.835.835,0,0,1,1.18,0l7.165,7.165a.832.832,0,0,1,0,1.176h0A.832.832,0,0,1-707.01,13Z",
  transform: "translate(1360.924 516.407)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3496",
  "data-name": "Path 3496",
  d: "M9693.379,17711.166h38.451",
  transform: "translate(-9076.687 -17196.607)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 2
})))));

function SvgStepper6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 219.906,
    height: 200.318,
    viewBox: "0 0 219.906 200.318",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepper6);
export default __webpack_public_path__ + "static/media/stepper6.4d7ee30ccb619e575b789d8ced08019e.svg";
export { ForwardRef as ReactComponent };